module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_square_blonde.410166a8.png";